import { Toast, ToastTitle } from "@fluentui/react-components";

export const notify = (title: string) => (
  <Toast style={{ width: "250px" }}>
    <ToastTitle>{title}</ToastTitle>
  </Toast>
);
